function fun(doc, win, clientWidth, designWidth) {
  var docEl = doc.documentElement,
    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
    recalc = function () {
      // var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      // 1rem = 20px；
      // 可以根据实际需要修改
      docEl.style.fontSize = 20 * (clientWidth / designWidth) + "px";
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
}
fun(document, window, document.documentElement.offsetWidth, 375);
window.onresize = function () {
  fun(document, window, document.documentElement.offsetWidth, 375);
};



//////////////////
// WEBPACK FOOTER
// ./static/common/rem.js
// module id = xl2I
// module chunks = 36